import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import TradeAcademyAppIcon from 'housecall-ui/dist/IconsAndImages/Logos/TradeAcademyLogo';
import { AmplitudeFlagKeys } from 'types/amplitudeFlags';

import TradeAcademyButton from '../OtherComponents/TradeAcademyButton';

const TradeAcademyStrategy = {
  previewInfo: {
    name: 'TradeAcademy.com',
    iconSvg: <TradeAcademyAppIcon size="xlarge" />,
    newTab: false,
    featureFlagName: AmplitudeFlagKeys,
  },
  headerInfo: {
    name: 'TradeAcademy.com',
    category: 'Post jobs, get applicants, and hire techs for your company',
    details: (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography paragraph>
            When we ask our Pros what the biggest problem they have in their business is the overwhelming response every
            time is “HIRING”.
          </Typography>
          <Typography paragraph>
            So we created{' '}
            <Link href="http://tradeacademy.com" target="_blank">
              Trade Academy
            </Link>
            .
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>What is it?</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            Trade Academy is the first job board specifically for home service businesses and job seekers.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>How does it work?</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography paragraph>
            Trade Academy focuses on delivering value to trade school students, job seekers, and home service business
            owners alike. The site is a free resource that hosts industry-specific job boards where home service
            businesses can create an employer profile, post open job listings, and search resumes of qualified
            candidates in their area.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>Benefits:</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            - Post open positions in your company with hundreds of job description templates
            <br />
            - Access resumes of qualified techs so that you can reach out before your competitors do
            <br />
            - Easily receive and manage applications
            <br />
            - Get weekly hiring resources specially for HVAC
            <br />
          </Typography>
        </Grid>
      </Grid>
    ),
    iconSvg: <TradeAcademyAppIcon size="xlarge" />,
  },
  sellingPoints: {},
  price: {
    title: 'Housecall Pro Plan',
    price: 'FREE',
    hideToggle: true,
    showBetaButton: false,
    appActionButton: <TradeAcademyButton />,
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials+ plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  supportContacts: [{ type: 'Email', contact: 'tradeacademy@housecallpro.com' }],
};

export default TradeAcademyStrategy;
